import api from '../api/api';

const API_URL = '/api/v1';

export interface Processo {
    id: number;
    numeroCnj: string;
    assunto: string;
    status: string;
    dataAutuacao: string;
    valorCausa: number;
    clienteId: number;
    clienteNome: string;
}

export interface ProcessoDTO {
    numeroCnj: string;
    assunto: string;
    status: string;
    dataAutuacao: string;
    valorCausa: number;
    clienteId: number;
}

export const ProcessoFacade = {
    listarTodos: async (): Promise<Processo[]> => {
        const response = await api.get(`${API_URL}/processos`);
        if (response.data && Array.isArray(response.data.content)) {
            return response.data.content;
        }
        return Array.isArray(response.data) ? response.data : [];
    },

    buscarPorId: async (id: number): Promise<Processo> => {
        const response = await api.get(`${API_URL}/processos/${id}`);
        return response.data;
    },

    criar: async (processo: ProcessoDTO): Promise<Processo> => {
        const response = await api.post(`${API_URL}/processos`, processo);
        return response.data;
    },

    atualizar: async (id: number, processo: ProcessoDTO): Promise<Processo> => {
        const response = await api.put(`${API_URL}/processos/${id}`, processo);
        return response.data;
    },

    excluir: async (id: number): Promise<void> => {
        await api.delete(`${API_URL}/processos/${id}`);
    }
};